<!-- 数据详情弹窗 -->
<template>
  <el-dialog
    width="960px"
    title="浏览/播放数据统计"
    :visible.sync="detailDialogVisible"
    showClose
    append-to-body
    center
  >
  <div style="height:37px">
    <span class="title-name">{{detailData.name}}</span>
    <el-button class="btn fright" :class="{ isActive:searchParams.queryDateType === 2}" plain @click="tabBtn(2)">
      30天
    </el-button>
    <el-button class="btn fright" style="margin-right:10px" :class="{ isActive:searchParams.queryDateType === 1}" plain @click="tabBtn(1)">  15天
    </el-button>
  </div>
  <div class="dialog-a-box">
    <div id="weekAna" :style="{width: '100%', height: '500px'}"></div>
  </div>
  </el-dialog>
</template>
<script>
import { getProgramGroupDetailDate } from '@/resource/api/program-group-management'
export default {
  props: ['detailData'],
  components: {},
  data () {
    return {
      detailDialogVisible: false,
      maxPlayCount: '历史最高单日播放量：0',
      searchParams: {
        queryDateType: 1,
        programSetId: this.detailData.id
      },
      dataChartBox: null,
      dateXAxis: [],
      datatatat: []
    }
  },
  methods: {
    tabBtn (dateTime) {
      this.searchParams.queryDateType = dateTime
      this.getData(this.searchParams)
    },
    pageInit (data) {
      this.searchParams = {
        queryDateType: 1,
        programId: this.detailData.id
      }
      this.$nextTick(() => {
        this.pageInitEharts()
      })
    },
    // 加载数据
    getData (data) {
      const that = this
      // 绘制图表
      getProgramGroupDetailDate(data).then((res) => {
        if (res && res.code == 1) {
          that.maxPlayCount = '历史最高单日播放量：' + res.result.historyHighestPlayCount
          const setDataOptin = {
            title: {
              text: that.maxPlayCount
            },
            xAxis: {
              data: res.result.xAxis
            },
            series: [
              {
                data: res.result.series[0].data
              },
              {
                data: res.result.series[1].data
              }
            ]
          }
          that.dataChartBox.setOption(setDataOptin)
        }
      })
    },
    open () {
      this.detailDialogVisible = true // 打开弹出框
      this.pageInit()
    },
    handleClose () {
      this.detailDialogVisible = false
    },
    pageInitEharts () {
      // 基于准备好的dom，初始化echarts实例
      const option = {
        title: {
          text: '历史最高单日播放量：0',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
            color: '#606266'
          },
          subtextStyle: {
            fontSize: 14,
            fontWeight: 'normal',
            color: '#606266'
          }
        },
        legend: {
          right: 20,
          top: 20
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: '100px',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dateXAxis,
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: '次数',
          nameTextStyle: {
            align: 'right'
          },
          nameGap: 20,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '播放量',
            type: 'line',
            stack: '总量',
            data: []
          },
          {
            name: '浏览量',
            type: 'line',
            stack: '总量',
            data: []
          }
        ]
      }
      const dataChart = this.$echarts.init(document.getElementById('weekAna'), 'light')
      dataChart.setOption(option)
      this.dataChartBox = dataChart
      this.getData(this.searchParams)
    }
  }
}
</script>
<style scoped>
  .title-name{
    font-size: 20px;
    line-height: 40px;
  }
  .padding-left-20 {
    margin-right: 10px;
  }
  .isActive {
    background: #ecf5ff!important;
    border-color: #2187e7!important;
    color: #fff;
  }
  .btn {
    color: #2187e7;
    background: #fff;
    border-color: #b3d8ff;
  }
</style>
